export interface IFooterLink {
  label: string;
  to: string;
  testId: string;
}

export default [
  { label: 'Help Center', to: '/help-center', testId: 'help-center' },
  { label: 'Contact us', to: '/contact-us', testId: 'contact-us' },
  { label: 'About', to: '/about', testId: 'about' },
  { label: 'Terms & Conditions', to: '/tnc', testId: 'terms-conditions' },
  { label: 'Privacy Policy', to: '/privacypolicy', testId: 'privacy-policy' },
  { label: 'Crypto', to: '/crypto', testId: 'crypto' },
] as IFooterLink[];
